const companyDirectoryURL = "userfiles/Website-Contact-List.xlsx";

export const getCompanyDirectory = async (): Promise<any> => {
    let excelData: any[] = [];
    try {
        const requestInit: RequestInit = {
            method: "GET",
            headers: { "Content-Type": "arraybuffer" },
        };
        const resp = await fetch(companyDirectoryURL, requestInit);
        const XLSX = await import(/* webpackChunkName: "xlsx" */ "xlsx");

        const responseData = await resp.arrayBuffer();
        if (responseData) {
            const data = new Uint8Array(responseData);
            const arr = [];
            for (let i = 0; i !== data.length; ++i) {
                arr[i] = String.fromCharCode(data[i]);
            }
            const bstr = arr.join("");

            /* Call XLSX */
            const workbook = await XLSX.read(bstr, { type: "binary" });

            /* DO SOMETHING WITH workbook HERE */
            const firstSheetName = workbook.SheetNames[0];
            /* Get worksheet */
            const worksheet = workbook.Sheets[firstSheetName];
            excelData = await XLSX.utils.sheet_to_json(worksheet, { raw: true, defval: "" });
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    }
    return excelData;
};
